import { pickBy } from 'lodash';

/**
 * Remove keys with undefined propertie,
 * this used to map `css` values from stitches.
 */
const filterFalsyValue = (obj: object) =>
  pickBy(
    obj,
    (value) => value !== '$undefined' && value !== undefined && value !== ''
  );

export default filterFalsyValue;
